import { render, staticRenderFns } from "./JudgementResultModal.vue?vue&type=template&id=fafbabea&scoped=true"
import script from "./JudgementResultModal.vue?vue&type=script&lang=js"
export * from "./JudgementResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafbabea",
  null
  
)

export default component.exports